/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module MatchModule */

import {
    Component,
    Input,
    OnInit,
} from '@angular/core';

import { L10nService } from '@vmw/ngx-vip';
import { SchemaService } from 'ajs/modules/core/services/schema-service/schema.service';
import { HTTPStatusMatchConfigItem }
    from 'ajs/modules/match/factories/http-status-match.config-item.factory';

import * as globalL10n from 'global-l10n';

const { ENGLISH: dictionary, ...globalL10nKeys } = globalL10n;

/**
 * @description Component to show readonly information for HttpStatusMatch.
 * @author Abhinesh Gour
 */
@Component({
    selector: 'http-status-match-readonly',
    templateUrl: './http-status-match-readonly.component.html',
})
export class HttpStatusMatchReadonlyComponent implements OnInit {
    /**
     * HTTPStatusMatch message item instance.
     */
    @Input()
    public editable: HTTPStatusMatchConfigItem;

    /**
     * MatchOperation criteria to be passed to match-wrapper.
     */
    public matchCriteria: string;

    /**
     * statusCodesAndRanges will hold codes and ranges flatten array of type string.
     */
    public statusCodesAndRanges: string[];

    /**
     * Get keys from global source bundles for template usage.
     */
    public readonly globalL10nKeys = globalL10nKeys;

    constructor(
        private readonly l10nService: L10nService,
        private readonly schemaService: SchemaService,
    ) {
        this.l10nService.registerSourceBundles(dictionary);
    }

    /** @override */
    public ngOnInit(): void {
        this.matchCriteria = this.schemaService.getEnumValueLabel(
            'MatchOperation',
            this.editable.config.match_criteria,
        );
        this.statusCodesAndRanges = this.editable.getRangesAndCodesAsList();
    }

    /**
     * Used in *ngFor.
     */
    public trackByIndex(index: number): number {
        return index;
    }
}
